import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Unsubscribe from "@/pages/Unsubscribe";
import AdminLogin from "@/pages/AdminLogin";
import Pipeline from "@/pages/Pipeline";
import AdminVenues from "@/pages/AdminVenues";
import AdminVenueEdit from "@/pages/AdminVenueEdit";
import VenuePublic from "@/pages/VenuePublic";
import EventPublic from "@/pages/EventPublic";
import PortalLogin from "@/pages/PortalLogin";
import PortalAcceptInvite from "@/pages/PortalAcceptInvite";
import PortalDashboard from "@/pages/PortalDashboard";
import PortalEventEdit from "@/pages/PortalEventEdit";
import PortalContacts from "@/pages/PortalContacts";
import PortalGuestlist from "@/pages/PortalGuestlist";
import PortalEvents from "@/pages/PortalEvents";
import PortalEmbed from "@/pages/PortalEmbed";
import PortalVenue from "@/pages/PortalVenue";
import PortalMembers from "@/pages/PortalMembers";
import PortalPayments from "@/pages/PortalPayments";
import PortalScan from "@/pages/PortalScan";
import PortalEmail from "@/pages/PortalEmail";
import MembershipPublic from "@/pages/MembershipPublic";
import VenueApply from "@/pages/VenueApply";
import AdminApplications from "@/pages/AdminApplications";
import EmbedCalendar from "@/pages/EmbedCalendar";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import TicketPage from "@/pages/TicketPage";
import AdminContacts from "@/pages/AdminContacts";
import Terms from "@/pages/Terms";
import TicketTerms from "@/pages/TicketTerms";
import Privacy from "@/pages/Privacy";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";
import ProtectedPortalRoute from "@/components/ProtectedPortalRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedAdminRoute><Pipeline /></ProtectedAdminRoute>} />
          <Route path="/admin/venues" element={<ProtectedAdminRoute><AdminVenues /></ProtectedAdminRoute>} />
          <Route path="/admin/venues/:id" element={<ProtectedAdminRoute><AdminVenueEdit /></ProtectedAdminRoute>} />

          {/* Venue portal (venue user login + event management) */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal/accept-invite/:token" element={<PortalAcceptInvite />} />
          <Route path="/portal" element={<ProtectedPortalRoute><PortalDashboard /></ProtectedPortalRoute>} />
          <Route path="/portal/events" element={<ProtectedPortalRoute><PortalEvents /></ProtectedPortalRoute>} />
          <Route path="/portal/events/:id" element={<ProtectedPortalRoute><PortalEventEdit /></ProtectedPortalRoute>} />
          <Route path="/portal/contacts" element={<ProtectedPortalRoute><PortalContacts /></ProtectedPortalRoute>} />
          <Route path="/portal/guestlist" element={<ProtectedPortalRoute><PortalGuestlist /></ProtectedPortalRoute>} />
          <Route path="/portal/scan" element={<ProtectedPortalRoute><PortalScan /></ProtectedPortalRoute>} />
          <Route path="/portal/email" element={<ProtectedPortalRoute><PortalEmail /></ProtectedPortalRoute>} />
          <Route path="/portal/embed" element={<ProtectedPortalRoute><PortalEmbed /></ProtectedPortalRoute>} />
          <Route path="/portal/venue" element={<ProtectedPortalRoute><PortalVenue /></ProtectedPortalRoute>} />
          <Route path="/portal/members" element={<ProtectedPortalRoute><PortalMembers /></ProtectedPortalRoute>} />
          <Route path="/portal/payments" element={<ProtectedPortalRoute><PortalPayments /></ProtectedPortalRoute>} />

          {/* Admin contacts (aggregated) */}
          <Route path="/admin/contacts" element={<ProtectedAdminRoute><AdminContacts /></ProtectedAdminRoute>} />
          <Route path="/admin/applications" element={<ProtectedAdminRoute><AdminApplications /></ProtectedAdminRoute>} />

          {/* Public but unlisted */}
          <Route path="/v/:slug" element={<VenuePublic />} />
          <Route path="/v/:slug/membership" element={<MembershipPublic />} />
          <Route path="/apply" element={<VenueApply />} />
          <Route path="/v/:slug/:eventSlug" element={<EventPublic />} />

          {/* Public embeddable calendar (iframe target) */}
          <Route path="/embed/v/:slug" element={<EmbedCalendar />} />

          {/* Checkout + tickets (public) */}
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/t/:ticketId" element={<TicketPage />} />

          {/* Legal */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms/tickets" element={<TicketTerms />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Everything else -> landing */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
